export default __webpack_public_path__ + "static/media/mary-training-1-people.04732e1a.jpg";